import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";


@Injectable()
export class UserMgmtService {
  constructor(private _networkService: NetworkService) {}

  getUserListApi(query) {
    return this._networkService.get(
      "api/users/userList?" + query,
      null,
      null,
      "bearer"
    );
  }
  getUserRewardWeeklyApi(query) {
    return this._networkService.get(
      "api/userRewards?rewardType=weekly&" + query,
      null,
      null,
      "bearer"
    );
  }
  getUserRewardPermanentApi(query) {
    return this._networkService.get(
      "api/userRewards?rewardType=permanent&" + query,
      null,
      null,
      "bearer"
    );
  }
  updateUserStatus(user: any) {
    return this._networkService.put("api/users/", user, null, "bearer");
  }
}
